import { memo } from 'react'
import { Modal } from 'antd'
import './Privacy.less'
const Privacy = ({ open, onCancel }: any) => {
  return (
    <Modal
      wrapClassName='xieyi-modal'
      width={600}
      title={'隐私声明'}
      open={open}
      onCancel={onCancel}
      footer={null}
      maskClosable={true}
    >
      <div className='privacy-container'>
        <p>
          上海文果儿科技有限公司（以下简称“我们”）十分尊重用户（以下简称“您”）的隐私权，并将竭尽全力保护您的个人信息。本隐私声明将告知您我们如何收集、使用、处理、保护和分享您的个人信息。请您认真阅读并理解本隐私声明。
        </p>
        <h2>1.收集的个人信息 </h2>
        <p>我们可能会在以下情况下收集您的个人信息：</p>
        <ul>
          <li>（1）您使用本平台时主动提供的信息，如注册账号时提供的姓名、电子邮件地址、联系电话等；</li>
          <li>（2）您使用本平台时产生的信息，如您的操作记录、IP地址、设备信息等；</li>
          <li>（3）您使用本平台的交互行为信息，如搜索、浏览、评论等；</li>
          <li>（4）其他方向我们提供的信息，如社交媒体账号信息等。</li>
        </ul>
        <h2>2.使用的个人信息 </h2>
        <p>我们仅会在下列情况下使用您的个人信息： </p>
        <ul>
          <li>（1）为您提供本平台的服务； </li>
          <li>（2）为了遵守相关法律法规的规定、行政机关或司法机关的要求，或为了维护我们的合法权益；</li>
          <li>
            （3）为了向您提供个性化的服务或改善本平台的使用体验； （4）为了开展内部审计、数据分析和研究，以改善我们的服务和技术。
          </li>
        </ul>
        <h2>3.个人信息的保护</h2>
        <p>
          我们将采取合理的技术措施和管理措施，以保护您的个人信息的安全。同时，我们会建立内部安全审计机制，加强数据安全意识和保护意识的培养，并制定应急处理预案以应对突发事件。
        </p>
        <h2>4.个人信息的分享</h2>
        <p>我们仅会在下列情况下与第三方分享您的个人信息： </p>
        <ul>
          <li>（1）为了向您提供本平台的服务；</li>
          <li> （2）为了遵守相关法律法规的规定、行政机关或司法机关的要求，或为了维护我们的合法权益；</li>
          <li>（3）在您同意的情况下与第三方分享；</li>
          <li>（4）我们可能会将匿名化或去标识化处理后的信息分享给第三方，以便于更好地了解用户需求和改善我们的服务。</li>
        </ul>
        <h2>5.未成年人的个人信息保护</h2>
        <p>
          我们非常重视未成年人的个人信息保护。我们建议未成年人在使用本平台时应事先取得家长或法定监护人的同意。如果您是未成年人，在使用本平台前，请您仔细阅读本隐私声明并在法定监护人的指导下使用本平台。
        </p>
        <h2>6.Cookie技术和网站日志</h2>
        <p>
          我们可能会通过Cookie技术和网站日志收集您的信息。Cookie是一种技术，它是网站用来存储在您的电脑上的信息的一小段文本文件。网站日志则是我们自动收集的与您的计算机有关的信息，如浏览器类型、网页访问日期和时间等。
        </p>
        <p>
          我们使用Cookie技术和网站日志是为了了解用户的偏好和行为，以便于提供更好的服务和体验。如果您不想接受Cookie，您可以通过修改浏览器的设置来禁用Cookie。但是，请注意，如果您禁用Cookie，可能会影响您使用本平台的某些功能。
        </p>
        <h2>7.个人信息的存储和处理地点</h2>
        <p>我们的服务器可能位于中国境内或境外。在数据跨境传输时，我们将采取必要的安全措施，保障您的个人信息的安全。</p>
        <h2>8.您的权利</h2>
        <p>
          根据相关法律法规，您有权访问、更正、删除您的个人信息、撤回您的授权同意等。您还有权要求我们停止收集、处理或使用您的个人信息。如果您需要行使您的权利，请联系我们。
        </p>
        <h2>9.隐私声明的变更</h2>
        <p>
          我们可能会根据实际情况随时修改本隐私声明，并将最新版本的隐私声明发布在本平台上。如有任何实质性变更，我们会在本平台上发出通知。如果您继续使用本平台，即表示您同意受隐私声明的约束。
        </p>
        <h2>10.联系我们</h2>
        <p>如果您对本隐私声明有任何疑问或意见，请联系我们，我们会尽快回复您。</p>
        <p>联系人：上海文果儿科技有限公司</p>
        <p>联系电话：021-80513380 联系电子邮件：wepass_service@163.com</p>
      </div>
    </Modal>
  )
}

export default memo(Privacy)
